<!--
多层深入的子页面模板
-->
<style lang="less" scoped>
  @import "~@/public/less/index.less";
  .z-plugin-permission{
    width: 100%; height: 100% !important; overflow: hidden;
    .head{
      margin: 0 20px 20px 20px; font-size: 1.1em; font-weight: bold;
    }
    .return{
      cursor: pointer;
    }
    .subHead{
      margin-top: 20px;
    }
  }
</style>
<template>
  <div class="zee zee-component z-plugin-permission">
    <z-layout ref="zlayout"
              v-if="superApi && superColumns"
              :superPage="page"
              :superApi="api"
              @reloadData="loadData">
      <!-- 面包屑 -->
      <template #breadcrumb><div></div></template>
      <!-- 头部 -->
      <template #head>
        <div class="head">
          <div class="return" @click="$fan.page.open(returnUrl.url, returnUrl.query)">
            <icon-left /> {{superTitle || router.info.name}}
          </div>
          <div class="subHead" v-if="$slots.subHead"><slot name="subHead"></slot></div>
        </div>
      </template>
      <!-- 检索 -->
      <template #subHeadLeft v-if="$slots.subHeadLeft">
        <slot name="subHeadLeft"></slot>
      </template>
      <template #subHeadLeft v-else>
        <z-search :superFilter="page.filter"
                  :superColumns="superColumns"
                  @change="bindSearchChange"
                  @reloadData="reloadData()">
        </z-search>
      </template>
      <!-- 按钮组 -->
      <template #subHeadRight v-if="$slots.subHeadRight">
        <slot name="subHeadRight"></slot>
      </template>
      <template #subHeadRight v-else>
        <a-button-group>
          <a-button @click="loadData()" ><template #icon><icon-refresh /></template>刷新</a-button>
          <a-button type="primary" @click="$refs.zlayout.bindOpenCurd('新增')" ><template #icon><icon-plus /></template>新增</a-button>
        </a-button-group>
      </template>
      <!-- 子菜单 -->
      <template #menus v-if="menus && Object.keys(menus).length>1">
        <a-menu mode="inline"
                :style="{ height: '100%', borderRight: 0 }"
                :defaultOpenKeys="[`${router.topInfo.url}`]"
                :defaultSelectedKeys="[`${router.info.url}`]">
          <template v-for="(item, index) in menus">
            <a-sub-menu :key="index"
                        v-if="item.info.show &&
                              item.info.type==='menu' &&
                              item.info.level===(router.navInfo.level+1) &&
                              !item.info.hasTmp && item.info.hasChild">
              <template #title>
                <component :is="'icon-' + item.info.icon" />
                <span>{{item.info.name}}</span>
              </template>
              <template v-for="(item2, index2) in menus">
                <a-menu-item :key="index2"
                             v-if="item2.info.type==='menu' &&
                                   item2.topInfo.url===item.info.url &&
                                   item2.info.level===(router.navInfo.level+2)"
                             @click="$fan.page.open(index2, query)">
                    <span>
                      <component :is="'icon-' + item2.info.icon" />
                      <span>{{item2.info.name}}</span>
                    </span>
                </a-menu-item>
              </template>
            </a-sub-menu>
            <a-menu-item :key="'menu-' + index"
                         v-else-if="item.info.show &&
                                    item.info.level===(router.navInfo.level+1) &&
                                    item.info.hasTmp"
                         @click="$fan.page.open(index, query)">
                  <span>
                    <component :is="'icon-' + item.info.icon" />
                    <span>{{item.info.name}}</span>
                  </span>
            </a-menu-item>
          </template>
        </a-menu>
      </template>
      <!-- 列表 -->
      <template #body>
        <z-table :superData="data"
                 :superColumns="superColumns"
                 :superFilter="page.filter"
                 @change="bindTableChange">
          <template #actions="record">
            <slot name="actions" :record="record.record"></slot>
            <a-tooltip content="查看" position="bottom">
              <a-button @click="$refs.zlayout.bindOpenCurd('详情', record)"><template #icon><icon-eye /></template></a-button>
            </a-tooltip>
            <a-tooltip content="编辑" position="bottom">
              <a-button @click="$refs.zlayout.bindOpenCurd('编辑', record)"><template #icon><icon-edit /></template></a-button>
            </a-tooltip>
            <a-popconfirm content="删除不可恢复，是否继续？" position="br" @ok="bindDeleteRecord(record)">
              <a-tooltip position="bottom" content="删除" >
                <a-button status="danger"><template #icon><icon-delete /></template></a-button>
              </a-tooltip>
            </a-popconfirm>
          </template>
        </z-table>
      </template>
    </z-layout>
  </div>
</template>

<script>
    import { IconLeft } from '@arco-design/web-vue/es/icon'
    export default {
    name: 'ZPluginPath',
    components: { IconLeft },
    props: {
      superTitle: String,
      superApi: String,
      superColumns: Array,
      superQuery: Array
    },
    created() {
      this.page = this.$fan.utils.parse(this.def.page)
      this.data = this.$fan.utils.parse(this.def.data)
    },
    mounted() {
      if (!this.superQuery) {
        this.$message.error('页面模板未设置必要参数')
      } else if (this.query && this.superQuery) {
        if (this.superApi && this.superColumns) {
          this.reloadData()
        }
      } else {
        this.$message.error('页面缺少必要参数')
      }
    },
    computed: {
      routers() {
        return this.$store.state.routers || {}
      },
      router() {
        return this.routers[this.$route.path] || {}
      },
      menus() {
        let menus = {}
        if (this.router && this.router.navInfo && this.router.navInfo.hasChild) {
          for (let k in this.routers) {
            const router = this.routers[k]
            if (router.info.type!=='nav' && router.topInfo.url===this.router.topInfo.url) {
              menus[router.info.url] = router
            }
          }
        }
        return Object.keys(menus).length>0 ? menus : false
      },
      query() {
        const query = this.$route.query
        if (this.$fan.utils.notEmpty(query)) {
          return query
        } else {
          return false
        }
      },
      api() {
        let api = this.superApi.split('?')
        if (this.superQuery) {
          let query = []
          for (var k in this.query) {
            if (this.superQuery.indexOf(k) > -1) {
              query.push(`${k}=${this.query[k]}`)
            }
          }
          query = query.join('&')
          if (api.length > 1) {
            return `${this.superApi}&${query}` || ''
          } else {
            return `${this.superApi}?${query}` || ''
          }
        }
      },
      returnUrl() {
        const breadcrumb = this.router.info.breadcrumb
        if (breadcrumb.length > 2) {
          let returnUrl = {name: "首页", icon: "home", url: "/", query: {}}
          if (breadcrumb[breadcrumb.length-2] && this.routers[breadcrumb[breadcrumb.length-2].url].info.hasTmp) {
            returnUrl = breadcrumb[breadcrumb.length-2]
          } else if (breadcrumb[breadcrumb.length-3] && this.routers[breadcrumb[breadcrumb.length-3].url].info.hasTmp) {
            returnUrl = breadcrumb[breadcrumb.length-3]
          } else if (breadcrumb[breadcrumb.length-4] && this.routers[breadcrumb[breadcrumb.length-4].url].info.hasTmp) {
            returnUrl = breadcrumb[breadcrumb.length-4]
          }
          const query = this.$fan.storage.getStorage('fan-page_query', this.router.topInfo.url)
          returnUrl.query = query
          return returnUrl
        } else {
          return {name: "首页", icon: "home", url: "/", query: {}}
        }
      },
    },
    data() {
      return {
        data: {}, page: {},
        def: {
          data: {},
          page: {
            initing: false,
            loading: false,
            filter: {
              page: 1,
              limit: 10
            }
          }
        }
      }
    },
    methods: {
      async loadData() {
        this.page.loading = true
        const {data} = await this.$fan.api.get(this.api, this.page.filter)
        this.data = data
        this.$store.state.page.data = data
        this.page.loading = false
      },
      async reloadData() {
        this.page.initing = true
        this.page.filter = this.$fan.utils.parse(this.def.page.filter)
        await this.loadData()
        await this.$fan.page.loadCallback(this.superColumns, this.data)
        this.page.initing = false
      },
      async bindSearchChange(filter={}) {
        this.page.loading = true
        this.page.filter = {...filter, ...this.def.page.filter}
        await this.loadData()
        await this.$fan.page.loadCallback(this.superColumns, this.data)
        this.page.loading = false
      },
      bindTableChange(pagination, filters, sorter) {
        this.page.filter.page = pagination.current
        this.page.filter.limit = pagination.pageSize
        this.loadData()
      },
      async bindDeleteRecord({record}) {
        let api = this.api.split('?')[0]
        await this.$fan.api.delete(`${api}/${record.id}`)
        this.loadData()
      },
      bindOpenCurd(title, record) {
        this.$refs.zlayout.bindOpenCurd(title, record)
      }
    }
  }
</script>
